/**
 * Top-level paths of the public contract pages, which must never be a customer's
 * landing page: a customer page at /verify could show a forged "verified" for any
 * contract. /verify sits inside a route group, where the app-folder scan in
 * `reserved-slugs.ts` can't see it; both are listed here so neither depends on
 * that scan. Pure, so the middleware and client-side code can import it.
 */
export const PUBLIC_ROUTE_SLUGS: readonly string[] = ["verify", "sign"];

/**
 * Whether a slug is one of the public contract pages' paths.
 *
 * @param slug - A landing page slug or first path segment.
 * @returns True for "verify" and "sign", in any case or spacing.
 */
export function isPublicRouteSlug(slug: string): boolean {
  return PUBLIC_ROUTE_SLUGS.includes(slug.trim().toLowerCase());
}
